import React from 'react';
import { useTranslation } from 'react-i18next';

function Differentiator() {
  const { t } = useTranslation();
  
  return (
    <section className="section differentiator-section" id="differentiator">
      <div className="container">
        <span className="section-label">{t('differentiator.label')}</span>
        <h2 className="section-title">{t('differentiator.title')}</h2>

        <div className="comparison-table">
          <div className="comparison-col comparison-col-left">
            <h3 className="comparison-col-title">{t('differentiator.standard.title')}</h3>
            <ul className="comparison-list">
              <li className="comparison-item-empty">{t('differentiator.standard.item1')}</li>
              <li className="comparison-item-empty">{t('differentiator.standard.item2')}</li>
              <li className="comparison-item-empty">{t('differentiator.standard.item3')}</li>
              <li className="comparison-item-empty">{t('differentiator.standard.item4')}</li>
            </ul>
            <div className="comparison-result comparison-result-negative">
              {t('differentiator.standard.result')}
            </div>
          </div>

          <div className="comparison-col comparison-col-right">
            <h3 className="comparison-col-title">{t('differentiator.ourobor.title')}</h3>
            <ul className="comparison-list">
              <li className="comparison-item-filled">{t('differentiator.ourobor.item1')}</li>
              <li className="comparison-item-filled">{t('differentiator.ourobor.item2')}</li>
              <li className="comparison-item-filled"><b>{t('differentiator.ourobor.item3')}</b></li>
              <li className="comparison-item-filled">{t('differentiator.ourobor.item4')}</li>
            </ul>
            <div className="comparison-result comparison-result-positive">
              {t('differentiator.ourobor.result')}
            </div>
          </div>
        </div>

        <div className="differentiator-statement">
          <p>{t('differentiator.statement1')}</p>
          <p className="statement-highlight">{t('differentiator.statement2')}</p>
        </div>
      </div>
    </section>
  );
}

export default Differentiator;
